import { BaseContainerModel } from '../base-container.model';
import * as fromDatatype from '../../datatype-library/index';

import {
  bl_pgw_payment_channel_ext_RowInterface,
  bl_pgw_payment_channel_hdr_RowInterface,
  bl_pgw_payment_channel_hdr_RowClass
} from '../../dbschema';

export class PaymentChannelContainerModel extends BaseContainerModel {
  bl_pgw_payment_channel_hdr: bl_pgw_payment_channel_hdr_RowInterface = new bl_pgw_payment_channel_hdr_RowClass();
  bl_pgw_payment_channel_exts: bl_pgw_payment_channel_ext_RowInterface[] = [];
  payment_channel_logo?: fromDatatype.VarcharDatatypeInterface;
}
